/*
 * rheincool — Bewertungs-Vorschau (Hovercard an der Sternebewertung)
 *
 * Beim Überfahren der Bewertung erscheint eine Karte mit echten Kundenstimmen
 * plus Herkunftszeile. Die Stimmen kommen aus der Section „Bewertungs-Vorschau"
 * im Header-Bereich — eine Quelle für alle drei Fundstellen (USP-Leiste,
 * Footer, Produktseite).
 *
 * Bewusste Entscheidungen:
 * - EINE Karte für alle Auslöser, nicht eine pro Bewertung. Sie wird an den
 *   Body gehängt und frei positioniert, damit sie nicht am overflow des
 *   Headers oder des Footers abgeschnitten wird.
 * - Öffnet auch bei Tastaturfokus, nicht nur bei Hover. Escape schließt.
 * - Kein Inhalt mit Links: So bleibt es ein echtes Tooltip, das keinen Fokus
 *   fängt. Der Weg zu allen Bewertungen ist die Bewertung selbst.
 * - Auf Touch-Geräten gar nicht erst aktiv (kein Hover, und ein Tap soll dem
 *   Link folgen statt eine Karte zu öffnen).
 */
(() => {
  const daten = document.getElementById('rc-rating-preview-daten');
  if (!daten) return;
  if (window.matchMedia('(hover: none)').matches) return;

  let konfig;
  try {
    konfig = JSON.parse(daten.textContent);
  } catch {
    return;
  }
  if (!konfig.stimmen || konfig.stimmen.length === 0) return;

  const OEFFNEN_MS = 180;
  const SCHLIESSEN_MS = 160;
  const ABSTAND = 10;

  let karte = null;
  let aktiverAusloeser = null;
  let oeffnenTimer = null;
  let schliessenTimer = null;

  function karteBauen() {
    const el = document.createElement('div');
    el.className = 'rc-rating-preview';
    el.id = 'rc-rating-preview';
    if (!konfig.ziel) el.setAttribute('role', 'tooltip');
    el.hidden = true;

    const anzahl = Math.min(konfig.max || 3, konfig.stimmen.length);
    const liste = document.createElement('ul');
    liste.className = 'rc-rating-preview__list';
    konfig.stimmen.slice(0, anzahl).forEach((stimme) => {
      const li = document.createElement('li');
      li.className = 'rc-rating-preview__item';

      const sterne = document.createElement('span');
      sterne.className = 'rc-rating-preview__stars';
      sterne.setAttribute('aria-hidden', 'true');
      sterne.textContent = '★★★★★';

      const text = document.createElement('p');
      text.className = 'rc-rating-preview__text';
      text.textContent = stimme.text;

      li.append(sterne, text);

      if (stimme.meta) {
        const meta = document.createElement('p');
        meta.className = 'rc-rating-preview__meta';
        meta.textContent = stimme.meta;
        li.append(meta);
      }
      liste.append(li);
    });

    const fuss = document.createElement('p');
    fuss.className = 'rc-rating-preview__source';
    fuss.textContent = konfig.hinweis || '';

    /* Die Schlusszeile ist ein echter Link aufs eBay-Profil. Vorher stand hier
       „Klicken für alle Bewertungen" als reiner Text — die Karte forderte zum
       Klicken auf und war nirgends klickbar. Weil sie jetzt einen Link führt,
       ist sie kein Tooltip mehr im Sinne der ARIA-Regeln (ein Tooltip darf
       keine Bedienelemente enthalten): role und aria-describedby entfallen. */
    const mehr = document.createElement(konfig.ziel ? 'a' : 'p');
    mehr.className = 'rc-rating-preview__more';
    mehr.textContent = konfig.mehr || '';
    if (konfig.ziel) {
      mehr.href = konfig.ziel;
      mehr.target = '_blank';
      mehr.rel = 'noopener nofollow';
      mehr.dataset.rcTrack = 'reviews_source_click';
      mehr.dataset.rcTrackQuelle = 'hovercard';
    }

    const pfeil = document.createElement('span');
    pfeil.className = 'rc-rating-preview__arrow';
    pfeil.setAttribute('aria-hidden', 'true');

    el.append(liste, fuss, mehr, pfeil);
    document.body.append(el);
    return el;
  }

  /* Karte über oder unter dem Auslöser, je nachdem wo Platz ist, und
     waagerecht im Viewport gehalten. */
  function positionieren(ausloeser) {
    const rect = ausloeser.getBoundingClientRect();
    const breite = karte.offsetWidth;
    const hoehe = karte.offsetHeight;
    const platzUnten = window.innerHeight - rect.bottom;
    const untenAnzeigen = platzUnten > hoehe + ABSTAND || rect.top < hoehe + ABSTAND;

    let links = rect.left + rect.width / 2 - breite / 2;
    links = Math.max(8, Math.min(links, window.innerWidth - breite - 8));
    const oben = untenAnzeigen ? rect.bottom + ABSTAND : rect.top - hoehe - ABSTAND;

    karte.style.left = `${Math.round(links)}px`;
    karte.style.top = `${Math.round(oben)}px`;
    karte.classList.toggle('rc-rating-preview--unten', untenAnzeigen);
    karte.classList.toggle('rc-rating-preview--oben', !untenAnzeigen);

    /* Pfeil auf die Mitte des Auslösers, nicht auf die Mitte der Karte —
       am Viewportrand sind das zwei verschiedene Punkte. */
    const pfeilX = rect.left + rect.width / 2 - links;
    karte.style.setProperty('--rc-preview-pfeil', `${Math.round(pfeilX)}px`);
  }

  function oeffnen(ausloeser) {
    clearTimeout(schliessenTimer);
    if (aktiverAusloeser === ausloeser && !karte.hidden) return;

    aktiverAusloeser = ausloeser;
    karte.hidden = false;
    positionieren(ausloeser);
    /* Reflow erzwingen statt requestAnimationFrame: In inaktiven oder
       gedrosselten Tabs kann rAF ausbleiben — die Karte hinge dann sichtbar
       auf opacity 0 fest. Das Auslesen von offsetHeight erzwingt das Layout,
       danach greift die Transition zuverlässig. */
    void karte.offsetHeight;
    karte.classList.add('is-open');
    if (!konfig.ziel) ausloeser.setAttribute('aria-describedby', 'rc-rating-preview');
  }

  function schliessen() {
    if (!karte || karte.hidden) return;
    karte.classList.remove('is-open');
    if (aktiverAusloeser) aktiverAusloeser.removeAttribute('aria-describedby');
    aktiverAusloeser = null;
    /* erst nach dem Ausblenden aus dem Fluss nehmen */
    schliessenTimer = setTimeout(() => {
      if (karte && !karte.classList.contains('is-open')) karte.hidden = true;
    }, 200);
  }

  function verzoegertOeffnen(ausloeser) {
    clearTimeout(schliessenTimer);
    clearTimeout(oeffnenTimer);
    oeffnenTimer = setTimeout(() => oeffnen(ausloeser), OEFFNEN_MS);
  }

  function verzoegertSchliessen() {
    clearTimeout(oeffnenTimer);
    clearTimeout(schliessenTimer);
    schliessenTimer = setTimeout(schliessen, SCHLIESSEN_MS);
  }

  karte = karteBauen();

  /* Die Karte selbst hält offen — sonst klappt sie weg, sobald der Zeiger
     den Spalt zwischen Bewertung und Karte kreuzt. */
  karte.addEventListener('mouseenter', () => clearTimeout(schliessenTimer));
  karte.addEventListener('mouseleave', verzoegertSchliessen);

  document.querySelectorAll('[data-rc-rating-trigger]').forEach((ausloeser) => {
    ausloeser.addEventListener('mouseenter', () => verzoegertOeffnen(ausloeser));
    ausloeser.addEventListener('mouseleave', verzoegertSchliessen);
    ausloeser.addEventListener('focus', () => oeffnen(ausloeser));
    ausloeser.addEventListener('blur', schliessen);
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') schliessen();
  });

  /* Beim Scrollen mitwandern wäre unruhig — die Karte hängt an einer festen
     Position, also lieber schließen. */
  window.addEventListener('scroll', schliessen, { passive: true });
  window.addEventListener('resize', schliessen);
})();
